import api from './api';

const authService = {
  // Connexion utilisateur
  login: async (credentials) => {
    return await api.post('/auth/login', credentials);
  },
  
  // Inscription utilisateur
  register: async (userData) => {
    return await api.post('/auth/register', userData);
  },
  
  // Vérification d'email
  verifyEmail: async (token) => {
    return await api.get(`/auth/verify-email/${token}`);
  },
  
  // Demande de réinitialisation de mot de passe
  forgotPassword: async (email) => {
    return await api.post('/auth/forgot-password', { email });
  },
  
  // Réinitialisation du mot de passe
  resetPassword: async (data) => {
    return await api.post('/auth/reset-password', data);
  },

  // Renvoi de l'email de vérification (public)
  resendVerification: async (email) => {
    return await api.post('/auth/resend-verification', { email });
  },
  
  // Récupération du profil utilisateur
  getProfile: async () => {
    return await api.get('/auth/profile');
  },
  
  // Mise à jour du profil utilisateur
  updateProfile: async (userData) => {
    return await api.put('/auth/profile', userData);
  },
  
  // Changement de mot de passe
  changePassword: async (passwords) => {
    return await api.put('/auth/change-password', passwords);
  },

  // Préférences de notifications email
  getEmailNotifications: async () => {
    return await api.get('/auth/me/email-notifications');
  },

  updateEmailNotifications: async (emailNotifications) => {
    return await api.put('/auth/me/email-notifications', { emailNotifications });
  },

  getVacations: async () => {
    return await api.get('/auth/me/vacations');
  },

  createVacation: async (vacation) => {
    return await api.post('/auth/me/vacations', vacation);
  },

  updateVacation: async (id, vacation) => {
    return await api.put(`/auth/me/vacations/${id}`, vacation);
  },

  deleteVacation: async (id) => {
    return await api.delete(`/auth/me/vacations/${id}`);
  }
};

export default authService;